<template>
  <naj-modal
    ref="modal"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <v-form ref="reasonForm">
      <naj-input
        :type-id="formFieldType.textarea"
        :value.sync="formModel.reason"
        :label="local.common.cancelReason"
        validates="required"
      ></naj-input>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button @click="submit(closeNajModal)">
        {{ local.common.save }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
export default {
  name: 'RequestNotesModal',
  props: ['modalVisibility', 'formModel'],
  watch: {
    modalVisibility(newValue) {
      if (newValue) {
        this.$refs.modal.show();
      } else
        this.$refs.modal.close();
    },
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    closeModal() {
      this.$set(this.formModel, 'reason', null);
      this.$emit('onCloseRequestNotesModal');
    },
    submit() {
      if (this.$refs.reasonForm)
        this.$refs.reasonForm.$validator.validateAll()
          .then((valid) => {
            if (valid) {
              this.$emit('onCloseRequestNotesModal');
            }
          });
    },
  },
};
</script>

<style lang="scss" scoped></style>
